export const removePreviousVersionsStorage = (prefix: string, currentVersion: string): void => {
    for (const key in localStorage) {
      const [, keyPrefix, keyVersion] = key.split(':');
      const oldStore = localStorage.getItem(key)
      if (keyPrefix !== prefix) continue;
  
      if (keyVersion !== currentVersion) {
        if(oldStore) {
          localStorage.setItem(`persist:${prefix}:${currentVersion}`, oldStore);
        }
        localStorage.removeItem(key);
      }
    }
  };